import { locale } from 'icreate/common/validators/yup-locale';
import * as yup from 'yup';
import { ObjectSchema, object, string } from 'icreate/common/validators/index';
yup.setLocale(locale);

export class CreateSystemColor {
    name: string;
    color: string;
}

export function SystemColorValidator(): ObjectSchema<CreateSystemColor> {
    return object({
        name: string().nonNullable().strict().required().max(32),
        color: string().nonNullable().strict().required(),
    })
        .noUnknown()
        .strict();
}
